<template>
	<el-card>
		<div slot="header">
			<span>开票信息</span>
		</div>
		<el-descriptions :column="2" border>
			<el-descriptions-item label="开票类型">
				{{ getInvoiceTypeName(invoiceData.invoiceType) }}
			</el-descriptions-item>
			<el-descriptions-item label="开票金额">{{ invoiceData.money }}元</el-descriptions-item>
			<el-descriptions-item v-if="!isMore" :label="setTitle">
				{{ invoiceData.identification }}
			</el-descriptions-item>
			<el-descriptions-item v-if="!isMore" label="发票抬头">
				{{ invoiceData.title }}
			</el-descriptions-item>
			<template v-if="invoiceData.invoiceType === '1' && invoiceData.bankName">
				<el-descriptions-item label="注册地址">
					{{ invoiceData.address }}
				</el-descriptions-item>
				<el-descriptions-item label="注册电话">
					{{ invoiceData.phone }}
				</el-descriptions-item>
				<el-descriptions-item label="开户银行">
					{{ invoiceData.bankName }}
				</el-descriptions-item>
				<el-descriptions-item label="开户账号">
					{{ invoiceData.bankNo }}
				</el-descriptions-item>
			</template>
			<template v-if="invoiceData.invoiceType === '1' && invoiceData.mailName">
				<el-descriptions-item label="收件人">
					{{ invoiceData.mailName }}
				</el-descriptions-item>
				<el-descriptions-item label="手机号">
					{{ invoiceData.mailPhone }}
				</el-descriptions-item>
				<el-descriptions-item label="收件人地址">
					{{ invoiceData.mailAreaName }}
				</el-descriptions-item>
				<el-descriptions-item label="详细地址">
					{{ invoiceData.mailAddress }}
				</el-descriptions-item>
			</template>
		</el-descriptions>
	</el-card>
</template>

<script>
import {dicInvoiceTypeMap} from 'meibao-insure/src/util/dicList'
import {isFgkZhuanpiao} from 'meibao-insure/src/util/productUtil'

export default {
	name: 'ViewInvoiceConfirm',
	props: {
		insureType: Boolean | Number,
		isMore: Boolean,
	},
	data: function () {
		return {
			invoiceData: {
				invoiceType: '',
				money: 0,
				identification: '',
				title: '',
				address: '',
				phone: '',
				bankName: '',
				bankNo: '',
				mailName: '',
				mailPhone: '',
				mailAreaName: '',
				mailAddress: '',
				taxCertificate: '',
			},
		}
	},
	computed: {
		setTitle() {
			return this.invoiceData.title === '个人' ? '身份证号' : '纳税人识别号'
		},
		//insureType 6 和21 ，上海太保去掉其他参数！！！！
		isZhuanPiaoHide() {
			return isFgkZhuanpiao(this.insureType)
		},
	},
	created() {
		this.init()
	},
	methods: {
		init() {},
		onSetInvoiceConfirmData(data) {
			Object.assign(this.invoiceData, data)
		},
		getInvoiceTypeName(invoiceType) {
			return dicInvoiceTypeMap.get(parseInt(invoiceType)) || ''
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions__header {
	margin-bottom: 10px;
}

::v-deep .el-descriptions-item__label {
	width: 100px !important;
}
</style>
